import { useLanguage } from '../contexts/LanguageContext';
import { Button } from './ui/button';

const LanguageToggle = () => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <Button
      data-testid="language-toggle"
      onClick={toggleLanguage}
      variant="outline"
      className="border-mecha-blue/30 hover:border-mecha-blue hover:bg-mecha-blue/10 transition-colors"
    >
      {language === 'en' ? 'العربية' : 'English'}
    </Button>
  );
};

export default LanguageToggle;
